import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { Token } from '../_models/token'
import { addToken, removeToken } from '../_actions/token.actions';
import { Injectable } from "@angular/core";


@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private store: Store<{}>) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: Token = JSON.parse(sessionStorage.getItem("token"));
    let correlationId = sessionStorage.getItem("correlationId");

    // Used to log into portal
    let tokenId = sessionStorage.getItem("tokenId");

    const isFormData =
      typeof FormData !== 'undefined' &&
      request.body instanceof FormData;

    // Preserve existing headers and only add/override what we need (avoids dropping Content-Type or other caller headers).
    let newHeaders = request.headers;

    // Only set JSON content type for JSON requests when not already set.
    // For FormData (multipart uploads), DO NOT set Content-Type so the browser can add the boundary.
    if (!request.url.includes('s3Upload/upload') && !isFormData && !request.headers.has('Content-Type')) {
      newHeaders = newHeaders.set('Content-Type', 'application/json');
    }

    if (!correlationId) {
      console.log('Creating new correlationId as none found in sessionStorage');
      correlationId = `${Date.now()}-${Math.floor(Math.random() * 1000000000) + 1}`
      sessionStorage.setItem('correlationId', correlationId);
    }

    newHeaders = newHeaders.set('correlationId', `${correlationId}`);

    if (token && token.token) {
      newHeaders = newHeaders.set('Authorization', token.token);
    }

    if (tokenId) {
      newHeaders = newHeaders.set('tokenId', `Bearer ${tokenId}`);
    }

    request = request.clone({
      headers: newHeaders
    });


    // if(request.url.includes('/v1/api/content')){
    //   console.log(`Interception ${request.url}`, request.headers.getAll("prismic-baseurl"),  request.headers.getAll("prismic-ref"));
    // }

    return next.handle(request).pipe(
      map(resp => {
        if (resp instanceof HttpResponse) {
          if (resp.headers.get('Authorization')) {
            let authorization: Token = {
              token: resp.headers.get("Authorization")
            }

            if (authorization.token !== null) {
              this.store.dispatch(addToken(authorization))
            } else {
              this.store.dispatch(removeToken())
            }
          }
        }
        return resp;
      })
    );
  }
}
